<template>
  <PreviewElementWrapper 
    :initial-selected="isSelected"
    :element-type="element.type"
    :element="element"
    :selectedPreviewId="selectedPreviewId"
    :disabled="disabled"
    @select-change="handleSelectChange"
    @update-element-data="$emit('update-element-data', $event)"
    @auto-mapping="(id)=>$emit('auto-mapping', id)"
    @element-edit-state-changed="$emit('element-edit-state-changed', $event)"
  >
    <div class="dummy-field-textarea" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
      <span class="placeholder-text"> Type your response here ... </span>
      <span class="input-length-limit"> 0/1000 characters </span>
      <FieldTooltip :visible="showTooltip" />
    </div>
  </PreviewElementWrapper>
</template>

<script>
import PreviewElementWrapper from './PreviewElementWrapper.vue';
import FieldTooltip from './FieldTooltip.vue';

export default {
  name: 'LongResponsePreview',
  components: { PreviewElementWrapper, FieldTooltip },
  props: {
    element: { type: Object, default: () => ({}) },
    selectedPreviewId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      showTooltip: false,
      isSelected: false
    };
  },
  emits: [
    'update-element-data',
    'auto-mapping',
    'element-edit-state-changed'
  ],
  methods: {
    handleSelectChange(isSelected) {
      this.isSelected = isSelected;
    }
  }
};
</script>

<style scoped>
.dummy-field-textarea {
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  background: #FFF;
  padding:8px 12px;
  height: 116px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.placeholder-text {
  color: #E0E0E0;

  /* VP_InputField_Content */
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
}
.input-length-limit {
  padding-left: 8px;
  color: #E0E0E0;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
}
</style>
